import React, { forwardRef, useEffect, useState } from 'react'
import { CustomModal } from '@components'
import { Box, FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, Typography, FormHelperText } from '@mui/material'
import { apiBuyIntraday, apiGetOrder } from '@store';
import { useDispatch } from 'react-redux';
import { showToast } from '@utils';

const Buy = forwardRef(({ handleClose, selectedContract, user }, ref) => {
    const dispatch = useDispatch();

    const [state, setState] = useState({
        market: 'NCG',
        type: 'buy',
        price_selected: '',
        seller: '',
        buyer: user?.CompanyShort,
        volume: '',
        ordertype: 'internal',
        sym: selectedContract
    })

    const [showVolumeError, setShowVolumeError] = useState(false)
    const [type, setType] = useState('ask')

    useEffect(() => {
        if (user?.CanBuyFrom?.length > 0) {
            setState((prevState) => ({
                ...prevState,
                seller: user.CanBuyFrom[0]
            }));
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target
        if (name === 'volume' && value !== '' && !/^\d*\.?\d{0,2}$/.test(value)) {
            return
        }
        setState({
            ...state,
            [name]: value
        })
        if (name === 'volume') {
            const vol = parseFloat(value)
            setShowVolumeError(value !== '' && !(vol > 0))
        }
    }

    // Add submitting state
    const [submitting, setSubmitting] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);

        const volume = parseFloat(state.volume)
        if (!(volume > 0)) {
            setShowVolumeError(true)
            showToast('error', 'Volume must be greater than 0')
            setSubmitting(false)
            return
        }

        const data = {
            ...state,
            volume,
        }

        const resp = await dispatch(apiBuyIntraday(data))
        if (resp?.meta?.requestStatus === 'fulfilled') {
            showToast('success', 'Purchase Order Saved')
            handleClose()
            dispatch(apiGetOrder())
            setSubmitting(false)
        } else if (resp?.meta?.requestStatus === 'rejected') {
            showToast('error', resp?.payload)
            setSubmitting(false)
        }
    }

    // timer
    const [timer, setTimer] = useState(60);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(timer => timer - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {
        if (timer === 0) {
            handleClose();
        }
    }, [timer, handleClose]);

    useEffect(() => {
        if (ref?.current) {
            setTimer(60);
        }
    }, [ref]);

    return (
        <CustomModal
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            timer={timer}
            modalTitle={`Buy Contract`}
            buttonText={'Buy'}
            disabled={submitting || !state.volume || submitting}
            ref={ref}
        >
            <Box className='flex flex-col gap-3'>
                    <FormControl fullWidth>
                        <InputLabel
                            id="demo-simple-select-label"
                            sx={{ bgcolor: '#F5F5F5', pr: 1 }}
                        >
                            Please Select what you would like to buy
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Type"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                        >
                            <MenuItem value={'ask'}>Ask Price</MenuItem>
                        </Select>
                    </FormControl>
                <Box className='flex gap-3'>
                    <Typography>Contract:</Typography>
                    <Typography color={'black'}>{selectedContract?.Contract}</Typography>
                </Box>
                <Box className='flex gap-3'>
                    <Typography>Max Volume User Can Buy:</Typography>
                    <Typography color={'black'}>{selectedContract?.Quantity}</Typography>
                </Box>
                <Box className='flex gap-3'>
                    <Typography>Price:</Typography>
                    <Typography color={'black'}>{selectedContract?.Price}</Typography>
                </Box>
                {/* <Box className='flex gap-3'>
                    <Typography>Settlement Price:</Typography>
                    <Typography color={'black'}>{selectedContract?.Price * state?.volume || 0}</Typography>
                </Box> */}
                <FormControl fullWidth variant="outlined" error={showVolumeError}>
                    <InputLabel
                        id="contractLabel"
                        sx={{ bgcolor: '#F5F5F5', p: '0 3px' }}
                    >
                        Volume
                    </InputLabel>
                    <OutlinedInput
                        id="volume"
                        label="Volume"
                        name="volume"
                        onChange={handleChange}
                        value={state.volume}
                        type="number"
                        inputProps={{ step: 0.01, min: 0 }}
                        required
                        endAdornment={
                            <InputAdornment position="start">
                                MW
                            </InputAdornment>
                        }
                    />
                    <FormHelperText>
                        {showVolumeError ? 'Volume must be greater than 0' : ''}
                    </FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel
                        id="demo-simple-select-label"
                        sx={{ bgcolor: '#F5F5F5', pr: 1 }}
                    >
                        Seller
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Seller"
                        name='seller'
                        value={state.seller}
                        onChange={handleChange}
                    >
                        {user?.CanBuyFrom?.map((seller, index) => (
                            <MenuItem key={index} value={seller}>{seller}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {/* <FormControl fullWidth>
                    <InputLabel
                        id="demo-simple-select-label"
                        sx={{ bgcolor: '#F5F5F5', pr: 1 }}
                    >
                        Delivery point
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Delivery point"
                    >
                        <MenuItem value='N/A'>N/A</MenuItem>
                    </Select>
                </FormControl> */}
            </Box>
        </CustomModal>
    )
})

export default Buy